import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
})
export class AppHeaderComponent implements OnInit {
  // @Output() action: EventEmitter = new EventEmitter();
  @Input() pageTitle = 'HOME';
  @Input() notificationMenu = true;
  @Input() messageMenu = false;
  @Input() settingMenu = false;
  @Input() addPatientMenu = false;
  @Input() supportCallMenu = false;

  settingsClicked = false;

  constructor() { }

  ngOnInit() { }

  // onMenuAction(args: string) {
  //   this.action.emit(args);
  // }

}
